<div class="register-success-container">
  <app-logo />

  <div class="register-success-container__img-bloc">
    <img
      role="presentation"
      alt=""
      src="./assets/images/register_success.jpg"
    />
  </div>

  <div class="register-success-container__text-container">
    <h1 class="register-success-container__text-container__h1">
      {{ 'registerAppSuccess_title' | translate }}
    </h1>

    <p class="register-success-container__text-container__p">
      {{ 'registerAppSuccess_contentFirstLine' | translate }}
      @if (user && user.profile) {
        <span class="bold-text" data-cs-mask>{{ user.profile.email }}</span>
      }
    </p>

    <p class="register-success-container__text-container__p">
      {{ 'registerAppSuccess_contentLastLine' | translate }}
      <app-contact-us-button
        appTracking="registration.contactSupport"
        labelKey="contactSupportPage_title"
      ></app-contact-us-button>
    </p>
  </div>
</div>
